import axios from "axios";
import {call, put, takeLatest} from "redux-saga/effects";
import {clearStatus, hideError, requestStatus, showErrorMessage} from "../../actions/global";
import { FULL_TRUCKLOAD, ORDER_PLANNING } from '../../../components/global/Server/endpoints';
import {SERVER_FAILED_ERROR_MESSAGE} from "../../../pages/Dashboard/DashboardFinal/constants";
import {
    FETCH_FULL_TRUCKLOAD_SETTINGS,
    FETCH_FULL_TRUCKLOADS,
    DELETE_FULL_TRUCKLOAD,
    LIST_FULL_TRUCKLOAD_BROKERS,
    LIST_FULL_TRUCKLOAD_CARRIERS,
    PREVIEW_FULL_TRUCKLOAD_FILE,
    PREVIEW_FULL_TRUCKLOAD_DOCUMENT,
    SAVE_FULL_TRUCKLOAD,
    SAVE_FULL_TRUCKLOAD_SETTINGS,
    UPDATE_FULL_TRUCKLOAD,
    UPLOAD_SIGNED_DOCUMENTS,
    SAVE_FULL_TRUCKLOAD_SIGNATURES,
    LIST_FULL_TRUCKLOAD_SIGNATURES,
    LIST_FULL_TRUCKLOAD_NOA_PORTS,
    SAVE_FULL_TRUCKLOAD_NOA_PORTS,
    FETCH_PRODUCT_SUPPLIERS,
    REIMPORT_FTL_FINAL_DOC,
    REGENERATE_FTL_DOCUMENT, UPDATE_FTL_DRAFT,
} from '../../constants/fullTruckload';
import {
    storeFullTruckloadBrokers,
    storeFullTruckloadCarriers,
    storeFullTruckloadOperationsResponse, storeFullTruckloadPorts,
    storeFullTruckloads,
    storeFullTruckloadSettings,
    storeSaveFtlSettingResponse,
    storeFullTruckloadSignatures,
    storeFullTruckloadUnavailableItems, storeProductsSuppliers, storeSavePOEResponse, storeSaveSignatureResponse,
    storeUpdatedFullTruckloadSettingsWithFile,
    storeUpdatedFullTruckloadSignaturesWithFile,
    storeUpdatedFullTruckloadWithFile
} from "../../actions/fullTruckload";
import {HTTP_SUCCESS} from "../../constants/global";
import {
    APPROVE_FTL, FTL_APPROVED_MESSAGE, FTL_DELETE_SUCCESSFUL_MESSAGE,
    FTL_MARKED_AS_COMPLETE_MESSAGE,
    FTL_MARKED_AS_DRAFT_MESSAGE,
    FTL_MARKED_AS_INCOMPLETE_MESSAGE,
    FTL_MARKED_AS_SHIPPED_MESSAGE,
    FTL_MARKED_AS_UNSHIPPED_MESSAGE,
    FTL_SAVED_SUCCESSFUL_MESSAGE, FTL_SETTING_SAVE_SUCCESSFUL_MESSAGE,
    FTL_UNAPPROVED_MESSAGE,
    FTL_UPDATED_SUCCESSFUL_MESSAGE,
    MARK_DRAFT_FTL,
    MARK_FTL_COMPLETE,
    MARK_FTL_INCOMPLETE,
    MARK_FTL_SHIPPED,
    MARK_FTL_UNSHIPPED,
    UNAPPROVE_FTL,
} from "../../../components/fullTruckload/constants";

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        "Authorization": `Bearer ${token}`
    }
}

const getRequest = (endpoint) => {
    return axios.get(endpoint, {
        headers: getHeaders()
    })
        .then(response => response);
}

const postRequest = (endpoint, data) => {
    return axios.post(endpoint, data, {
        headers: getHeaders()
    })
        .then(response => response)
}

function* saveFullTruckload(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.SAVE_FULL_TRUCKLOAD, {data : action.data, newSettings: action.newSettings}))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadOperationsResponse(FTL_SAVED_SUCCESSFUL_MESSAGE))
             if (action.callback && typeof action.callback === 'function') {
                 action.callback(response.data.success, response.data.fullTruckload);
             }else{
                yield action.reset()
             }


        }
        yield put(requestStatus(status))
        yield put(storeFullTruckloadUnavailableItems(response.data?.unavailableItems))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* regenerateFTLDocument(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.REGENERATE_FTL_DOCUMENT, {data : action.data}))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadOperationsResponse(response.data.message))
            yield action.reset()
        }
        else{
            yield put(showErrorMessage(response.data.message))
        }
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* updateFullTruckload(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.UPDATE_FULL_TRUCKLOAD, {data : action.data, newSettings: action.newSettings}))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            // if there is a change of status
            if (action.operationName !== undefined) {
                switch (action.operationName) {
                    case MARK_DRAFT_FTL:
                        yield put(storeFullTruckloadOperationsResponse(FTL_MARKED_AS_DRAFT_MESSAGE))
                        break
                    case APPROVE_FTL:
                        yield put(storeFullTruckloadOperationsResponse(FTL_APPROVED_MESSAGE))
                        break
                    case UNAPPROVE_FTL:
                        yield put(storeFullTruckloadOperationsResponse(FTL_UNAPPROVED_MESSAGE))
                        break
                    case MARK_FTL_UNSHIPPED:
                        yield put(storeFullTruckloadOperationsResponse(FTL_MARKED_AS_UNSHIPPED_MESSAGE))
                        break
                    case MARK_FTL_SHIPPED:
                        yield put(storeFullTruckloadOperationsResponse(FTL_MARKED_AS_SHIPPED_MESSAGE))
                        break
                    case MARK_FTL_INCOMPLETE:
                        yield put(storeFullTruckloadOperationsResponse(FTL_MARKED_AS_INCOMPLETE_MESSAGE))
                        break
                    case MARK_FTL_COMPLETE:
                        yield put(storeFullTruckloadOperationsResponse(FTL_MARKED_AS_COMPLETE_MESSAGE))
                        break
                }
            }
            // normal update response message
            else {
                yield put(storeFullTruckloadOperationsResponse(FTL_UPDATED_SUCCESSFUL_MESSAGE))
            }

             if (action.callback && typeof action.callback === 'function') {
                 action.callback(response.data.success, response.data.data);
             }else{
                yield action.reset(response.data.success)
             }
        }
        else if (response.data.message){
            yield put(showErrorMessage(response.data.message))
            if (action.callback && typeof action.callback === 'function') {
                action.callback(response.data.success, response.data.data);
            }else{
                yield action.reset(response.data.success)
            }
        }
        yield put(storeFullTruckloadUnavailableItems(response.data?.unavailableItems))

        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* updateFTLDraftSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(ORDER_PLANNING.UPDATE_FTL_DRAFT, {ftlEntry : action.data}))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadOperationsResponse(FTL_UPDATED_SUCCESSFUL_MESSAGE))

             if (action.callback && typeof action.callback === 'function') {
                 action.callback(response.data.success, response.data.fullTruckload);
             }
        }
        else if (response.data.message){
            if (action.callback && typeof action.callback === 'function') {
                 action.callback(response.data.success, response.data.message);
             }
            yield put(showErrorMessage(response.data.message))
        }

        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* uploadSignedDocuments(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.UPLOAD_SIGNED_DOCUMENTS, action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield action.reset()
            yield put(storeFullTruckloadOperationsResponse(response.data.message))
        }
        else {
            yield put(showErrorMessage(response.data.message))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* fetchFullTruckloads() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(FULL_TRUCKLOAD.FETCH_FULL_TRUCKLOADS))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloads(response.data.fullTruckloads))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* fetchProductSuppliers(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.FETCH_PRODUCT_SUPPLIERS, action.items))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeProductsSuppliers(response.data.result))
        }
        yield put(requestStatus(status))
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* deleteFullTruckloadSaga(action) {
    yield put(hideError())
    try{
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.DELETE_FULL_TRUCKLOAD, {fullTruckloadId : action.data}))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.data.success
        }
        if (response.status === 200 && response.data.success) {
            yield put(storeFullTruckloads(response.data.fullTruckloads))
            yield put(storeFullTruckloadOperationsResponse(FTL_DELETE_SUCCESSFUL_MESSAGE))
        } else {
            status.message = response.data?.message
            yield put(showErrorMessage(status.message))
            yield put(requestStatus(status))
        }
    }catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}
function* saveFullTruckloadSettings(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.SAVE_FULL_TRUCKLOAD_SETTINGS, action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadSettings(action.data))
            yield put(storeSaveFtlSettingResponse(FTL_SETTING_SAVE_SUCCESSFUL_MESSAGE))
            yield action.reset()
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* saveFullTruckloadSignatures(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.SAVE_FULL_TRUCKLOAD_SIGNATURES, action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeSaveSignatureResponse(response.data.message))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listFullTruckloadSignatures(action) {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(FULL_TRUCKLOAD.LIST_FULL_TRUCKLOAD_SIGNATURES))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadSignatures(response.data.fullTruckloadSignatures))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* saveFullTruckloadPOEs(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.SAVE_FULL_TRUCKLOAD_POEs, action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (!response.data.success) {
            yield put(showErrorMessage(response.data.message))
        }
        yield put(requestStatus(status))
        yield put(storeSavePOEResponse(FTL_SETTING_SAVE_SUCCESSFUL_MESSAGE))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listFullTruckloadPOEs(action) {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(FULL_TRUCKLOAD.LIST_FULL_TRUCKLOAD_POEs))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadPorts(response.data.noaPorts))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* fetchFullTruckloadSettings() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(FULL_TRUCKLOAD.FETCH_FULL_TRUCKLOAD_SETTINGS))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadSettings(response.data.fullTruckloadSettings))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* previewFullTruckloadAttachmentSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.PREVIEW_FULL_TRUCKLOAD_FILE, action.previewRequest))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (response.data.success) {
            switch ( action.previewRequest.type) {
                case "Attachment":
                    yield put(storeUpdatedFullTruckloadSettingsWithFile(response.data.fullTruckloadSettings, response.data.index))
                    break
                case "Signature":
                    yield put(storeUpdatedFullTruckloadSignaturesWithFile(response.data.fullTruckloadSignatures.signatures, response.data.index))
                    break
            }
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* previewFullTruckloadDocumentSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.PREVIEW_FULL_TRUCKLOAD_DOCUMENT, action.previewRequest))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (response.data.success) {
            yield put(storeUpdatedFullTruckloadWithFile(response.data.previewFile))
        }else{
            yield put(showErrorMessage(response.data.message))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listFullTruckloadCarriers() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(FULL_TRUCKLOAD.LIST_FULL_TRUCKLOAD_CARRIERS))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadCarriers(response.data.fullTruckloadCarriers))
        }
            yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listFullTruckloadBrokers() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(FULL_TRUCKLOAD.LIST_FULL_TRUCKLOAD_BROKERS))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === 200
        };
        if (response.data.success) {
            yield put(storeFullTruckloadBrokers(response.data.fullTruckloadBrokers))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* reimportFTLFinalDoc(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(FULL_TRUCKLOAD.REIMPORT_FTL_FINAL_DOC, action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (response.data.success) {
            yield put(storeUpdatedFullTruckloadWithFile(action.data.content))
        }
        yield put(requestStatus(status))
    }
    catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* fullTruckloadSagas() {
    yield takeLatest(SAVE_FULL_TRUCKLOAD, saveFullTruckload);
    yield takeLatest(FETCH_FULL_TRUCKLOADS, fetchFullTruckloads)
    yield takeLatest(DELETE_FULL_TRUCKLOAD, deleteFullTruckloadSaga)
    yield takeLatest(REIMPORT_FTL_FINAL_DOC, reimportFTLFinalDoc)
    yield takeLatest(FETCH_PRODUCT_SUPPLIERS, fetchProductSuppliers)
    yield takeLatest(UPDATE_FULL_TRUCKLOAD, updateFullTruckload)
    yield takeLatest(REGENERATE_FTL_DOCUMENT, regenerateFTLDocument);
    yield takeLatest(UPLOAD_SIGNED_DOCUMENTS, uploadSignedDocuments)
    yield takeLatest(LIST_FULL_TRUCKLOAD_SIGNATURES, listFullTruckloadSignatures)
    yield takeLatest(LIST_FULL_TRUCKLOAD_NOA_PORTS, listFullTruckloadPOEs)
    yield takeLatest(SAVE_FULL_TRUCKLOAD_NOA_PORTS, saveFullTruckloadPOEs)
    yield takeLatest(SAVE_FULL_TRUCKLOAD_SIGNATURES, saveFullTruckloadSignatures)
    yield takeLatest(SAVE_FULL_TRUCKLOAD_SETTINGS, saveFullTruckloadSettings)
    yield takeLatest(FETCH_FULL_TRUCKLOAD_SETTINGS, fetchFullTruckloadSettings)
    yield takeLatest(PREVIEW_FULL_TRUCKLOAD_FILE, previewFullTruckloadAttachmentSaga)
    yield takeLatest(PREVIEW_FULL_TRUCKLOAD_DOCUMENT, previewFullTruckloadDocumentSaga)
    yield takeLatest(LIST_FULL_TRUCKLOAD_CARRIERS, listFullTruckloadCarriers)
    yield takeLatest(LIST_FULL_TRUCKLOAD_BROKERS, listFullTruckloadBrokers)
    yield takeLatest(UPDATE_FTL_DRAFT, updateFTLDraftSaga)
}